/**
 * CodeMirror 6 language mode for 2LTT (Two-Level Type Theory).
 * Provides syntax highlighting for the input editor with universe 0/1 distinction.
 */
import { StreamLanguage } from "@codemirror/language";
import { Tag, tags } from "@lezer/highlight";
import { createTheme } from "@uiw/codemirror-themes";
// Custom tags for universe 0 vs 1 (modifiers of typeName)
var tagType0 = Tag.defineModifier()(tags.typeName);
var tagType1 = Tag.defineModifier()(tags.typeName);
// Stage 0 types: Nat0, U0, zero0, succ0, nat_elim0
var TYPE0_RE = /\b(Nat0|U0|zero0|succ0|nat_elim0)\b/;
// Stage 1 types: Nat1, U1, zero1, succ1, nat_elim1
var TYPE1_RE = /\b(Nat1|U1|zero1|succ1|nat_elim1)\b/;
// Keywords
var KEYWORD_RE = /\b(const|let|in)\b/;
// Identifiers
var IDENT_RE = /[a-zA-Z_][a-zA-Z0-9_]*/;
var twoLttParser = {
    name: "2ltt",
    startState: function () {
        return {};
    },
    token: function (stream) {
        // Whitespace
        if (stream.eatSpace())
            return null;
        // Multi-char operators first
        if (stream.match("=>"))
            return "operator";
        if (stream.match("->"))
            return "operator";
        // Single-char operators
        if (stream.eat(/[~^⇑<>=:]/))
            return "operator";
        // Punctuation
        if (stream.eat(/[()]/))
            return "punctuation";
        // Word tokens
        if (stream.match(KEYWORD_RE))
            return "keyword";
        if (stream.match(TYPE0_RE))
            return "type0";
        if (stream.match(TYPE1_RE))
            return "type1";
        // Numbers
        if (stream.match(/\d+/))
            return "number";
        // Identifiers
        if (stream.match(IDENT_RE))
            return "variableName";
        stream.next();
        return null;
    },
    languageData: {},
    tokenTable: {
        type0: tagType0,
        type1: tagType1,
    },
};
// Unified color palette (matches HighlightedOutput)
var colors = {
    keyword: "#c792ea",
    type0: "#89ddff",
    type1: "#ffb86c",
    identifier: "#82aaff",
    operator: "#c3e88d",
    punctuation: "#676e95",
    number: "#f78c6c",
    default: "#e2e8f0",
};
export var twoLttLanguage = StreamLanguage.define(twoLttParser);
// Custom theme with unified colors (replaces atomone to fix keyword color)
export var twoLttTheme = createTheme({
    theme: "dark",
    settings: {
        background: "#16161e",
        foreground: colors.default,
        caret: "#e2e8f0",
        selection: "#ffffff30",
        selectionMatch: "#2B323D",
        gutterBackground: "#16161e",
        gutterForeground: "#64748b",
        lineHighlight: "#1e1e2e",
    },
    styles: [
        { tag: tags.keyword, color: colors.keyword },
        { tag: tags.definitionKeyword, color: colors.keyword },
        { tag: tags.controlKeyword, color: colors.keyword },
        { tag: tags.moduleKeyword, color: colors.keyword },
        { tag: tagType0, color: colors.type0 },
        { tag: tagType1, color: colors.type1 },
        { tag: tags.variableName, color: colors.identifier },
        { tag: tags.operator, color: colors.operator },
        { tag: tags.punctuation, color: colors.punctuation },
        { tag: tags.number, color: colors.number },
    ],
});
